<template>
  <v-footer id="dashboard-core-footer" v-if="!isHiddenRoute">
    <v-container>
      <v-row align="center" no-gutters>
        <v-spacer class="hidden-sm-and-down" />

        <v-col cols="12" md="auto">
          <div class="body-1 font-weight-light pt-6 pt-md-0 text-center">
           {{   '&copy; ' + new Date().getFullYear() + ' GPDF' }}
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "DashboardCoreFooter",

  data: () => ({}),

  computed: {
    isHiddenRoute() {
      const hiddenRoutes = [
        '/modulos',
        '/portal-socios',
        '/velorios-andamento',
        '/recordacoes',
        '/nps',
        '/ecommerce',
        '/v2chat',
        '/chat',
        '/modulo-financeiro',
        '/modulo-comunicacao',
        '/modulo-comercial',
        '/modulo-assinatura-digital',
        '/modulo-colaborador'
      ];
      
      return hiddenRoutes.includes(this.$route.path);
    }
  }
};
</script>

<style lang="sass">
#dashboard-core-footer

    font-size: .825rem
    font-weight: 500
    text-decoration: none
    text-transform: uppercase
</style>
